import Vue from 'vue'

export const MODES = [
  {
    key: 'always',
    label: 'Автоматически добавлять работу при каждом выезде',
    active: (wT) => wT.inclusionMode === 'always', // wT.repeatable && !wT.repeatAgain && !wT.paused && !wT.repeatOnce,
    available: (wT) => true,
    set: (wT) => {
      Vue.set(wT, 'lastAppliedInclusionMode', wT.inclusionMode)
      Vue.set(wT, 'inclusionMode', 'always')
      // Vue.set(wT, 'repeatable', true)
      // Vue.set(wT, 'repeatAgain', false)
      // Vue.set(wT, 'paused', false)
      // Vue.set(wT, 'repeatOnce', false)
    },
    hidden: wT => false,
    icon: 'mdi-redo',
    tooltip: 'Работа добавляется автоматически при создании отчетов по каждому дополнительному выезду',
    beforeSetHint: 'После установки данного режима работа автоматически добавляется во вновь создаваемые отчеты по дополнительным выездам.'
  },
  {
    key: 'untilDone',
    label: 'Автоматически добавлять работу при каждом выезде до ее исполнения',
    active: (wT) => wT.inclusionMode === 'untilDone' && !wT.hasDoneReadyReports, // !wT.repeatable && !wT.repeatAgain && !wT.paused && !wT.repeatOnce,
    available: (wT) => !wT.hasDoneReadyReports,
    set: (wT) => {
      Vue.set(wT, 'lastAppliedInclusionMode', wT.inclusionMode)
      Vue.set(wT, 'inclusionMode', 'untilDone')
      // Vue.set(wT, 'repeatable', false)
      // Vue.set(wT, 'repeatAgain', false)
      // Vue.set(wT, 'paused', false)
      // Vue.set(wT, 'repeatOnce', false)
    },
    hidden: wT => wT.hasDoneReadyReports,
    icon: 'mdi-arrow-collapse-right',
    tooltip: 'Работа добавляется автоматически при создании отчетов по дополнительным выездам до ее исполнения',
    beforeSetHint: 'После установки данного режима работа автоматически добавляется во вновь создаваемые отчеты по дополнительным выездам до ее исполнения.'
  },
  {
    key: 'untilDoneAgain',
    label: 'Продолжить автоматическое добавление работы до повторного исполнения',
    active: (wT) => wT.inclusionMode === 'untilDone' && wT.hasDoneReadyReports, // !wT.repeatable && wT.repeatAgain && !wT.paused && wT.done && !wT.repeatOnce,
    available: (wT) => wT.hasDoneReadyReports,
    set: (wT) => {
      Vue.set(wT, 'lastAppliedInclusionMode', wT.inclusionMode)
      Vue.set(wT, 'inclusionMode', 'untilDone')
      // Vue.set(wT, 'repeatable', false)
      // Vue.set(wT, 'repeatAgain', true)
      // Vue.set(wT, 'paused', false)
      // Vue.set(wT, 'repeatOnce', false)
    },
    hidden: wT => !wT.hasDoneReadyReports,
    icon: 'svguse:/delta/dist/arrow-collapse-right-double.svg#arrow-collapse-right-double',
    tooltip: 'Работа выполнена и добавляется автоматически при создании отчетов по дополнительным выездам до ее повторного исполнения (ранее регистрировалось выполнение работы)',
    beforeSetHint: 'После установки данного режима работа автоматически будет добавлена в отчет по следующему дополнительному выезду или в текущий отчет (при установке галочки "Применить к текущему выезду")'
  },
  {
    key: 'stopped',
    label: 'Остановить автоматическое добавление работ',
    active: (wT) => wT.inclusionMode === 'stopped', // !wT.repeatable && !wT.repeatAgain && wT.paused && !wT.repeatOnce,
    available: (wT) => true,
    set: (wT) => {
      Vue.set(wT, 'lastAppliedInclusionMode', 'stopped')
      Vue.set(wT, 'inclusionMode', 'stopped')
      // Vue.set(wT, 'repeatable', false)
      // Vue.set(wT, 'repeatAgain', false)
      // Vue.set(wT, 'paused', true)
      // Vue.set(wT, 'repeatOnce', false)
    },
    hidden: wT => false,
    icon: 'mdi-pause-circle',
    tooltip: 'Остановлено автоматическое добавление работы при создании отчетов по дополнительным выездам',
    lastAppliedInclusionModeTooltip: (wt) => {
      switch (wt.lastAppliedInclusionMode) {
        case 'untilDone': return 'Работа добавлялась автоматически при каждом выезде до ее исполнения.<br>Работа исполнена и ее автоматическое добавление в отчеты по дополнительным выездам приостановлено.'
        case 'untilDoneAgain': return 'Работа добавлялась автоматически при каждом выезде до ее повторного исполнения.<br>Работа исполнена повторно и ее автоматическое добавление в отчеты по дополнительным выездам приостановлено.'
        case 'once': return 'Работа добавлена однократно в отчете об исполнении работ.<br>Автоматическое добавление работы при создании отчетов по дополнительным выездам приостановлено.'
        default: return ''
      }
    },
    beforeSetHint: 'После установки данного режима будет прекращено автоматическое добавление работы во вновь создаваемые отчеты по дополнительным выездам.'
  },
  {
    key: 'once',
    label: 'Однократное добавление работы',
    active: (wT) => wT.inclusionMode === 'once', // !wT.repeatable && !wT.repeatAgain && !wT.paused && wT.repeatOnce,
    available: (wT) => true,
    hidden: wT => true,
    set: (wT) => {
      Vue.set(wT, 'lastAppliedInclusionMode', wT.inclusionMode)
      Vue.set(wT, 'inclusionMode', 'once')
      // Vue.set(wT, 'repeatable', false)
      // Vue.set(wT, 'repeatAgain', false)
      // Vue.set(wT, 'paused', false)
      // Vue.set(wT, 'repeatOnce', true)
    },
    icon: 'mdi-numeric-1-box',
    tooltip: 'Работа добавлена однократно в отчете об исполнении работ',
    beforeSetHint: ''
  }
]

export const GROUP_INCLUSION_MODE_OPTIONS = [
  {
    value: 'resume',
    label: 'Возобновить автоматическое добавление работ',
    icon: 'mdi-play-circle',
    tooltip: 'Автоматическое добавление работ во вновь создаваемые отчеты будет возобновлено',
    children: [
      {
        parentValue: 'resume',
        value: 'resumeAll',
        label: 'Возобновить для всех работ',
        isApplicable: (workType) => workType.inclusionMode === 'stopped',
        changedWorkTypesCaption: 'Будет возобновлено автоматическое добавление:',
        mode: (workType, workTypeDefault = null) => MODES.find(mode => {
          if (workType.lastAppliedInclusionMode !== 'stopped' && workType.lastAppliedInclusionMode !== 'once') {
            return mode.key === workType.lastAppliedInclusionMode
          } else if (workType.hasDoneReports) {
            return mode.key === 'untilDoneAgain'
          } else if (!workType.hasDoneReports) {
            return mode.key === 'untilDone'
          }
          return false
        }),
        beforeSetHint: 'Работам будет установлен режим автоматического добавления до исполнения/повторного исполнения работы'
      },
      {
        parentValue: 'resume',
        value: 'resumeSelected',
        label: 'Возобновить для невыполненных работ',
        isApplicable: (workType) => workType.inclusionMode === 'stopped' && !workType.hasDoneReports && !workType.hasDoneMultipleReports,
        changedWorkTypesCaption: 'Будет возобновлено автоматическое добавление:',
        mode: (workType, workTypeDefault = null) => MODES.find(mode => {
          if (workType.hasDoneReports) {
            return mode.key === 'untilDoneAgain'
          } else if (!workType.hasDoneReports) {
            return mode.key === 'untilDone'
          }
          return false
        }),
        beforeSetHint: 'Невыполненным работам будет установлен режим автоматического добавления до исполнения/повторного исполнения работы'
      }
    ]
  },
  {
    value: 'pause',
    label: 'Остановить автоматическое добавление работ',
    icon: 'mdi-pause-circle',
    tooltip: 'Автоматическое добавление работ во вновь создаваемые отчеты будет остановлено',
    children: [
      {
        parentValue: 'pause',
        value: 'pauseAll',
        label: 'Приостановить для всех работ',
        isApplicable: (workType) => workType.inclusionMode !== 'stopped',
        changedWorkTypesCaption: 'Будет приостановлено автоматическое добавление:',
        mode: (workType, workTypeDefault = null) => MODES.find(mode => mode.key === 'stopped'),
        beforeSetHint: 'После установки данного режима будет прекращено автоматическое добавление работ во вновь создаваемые отчеты по дополнительным выездам.'
      },
      {
        parentValue: 'pause',
        value: 'pauseDone',
        label: 'Остановить для невыполненных работ',
        isApplicable: (workType) => workType.inclusionMode !== 'stopped' && !workType.hasDoneReports && !workType.hasDoneMultipleReports,
        changedWorkTypesCaption: 'Будет приостановлено автоматическое добавление:',
        mode: (workType, workTypeDefault = null) => MODES.find(mode => mode.key === 'stopped'),
        beforeSetHint: 'После установки данного режима будет прекращено автоматическое добавление невыполненных работ во вновь создаваемые отчеты по дополнительным выездам.'
      }
    ]
  },
  {
    value: 'change',
    label: 'Изменить режим автоматического добавления работ',
    icon: 'mdi-pencil-circle',
    tooltip: 'Выбрать режим автоматического добавления работ',
    children: MODES.filter(mode => ['always', 'untilDone'].includes(mode.key)).map(mode => ({
      parentValue: 'change',
      value: `changeTo${mode.key}`,
      label: mode.label,
      icon: mode.icon,
      tooltip: mode.tooltip,
      beforeSetHint: mode.beforeSetHint,
      isApplicable: (workType) => true,
      changedWorkTypesCaption: 'Будет изменен режим автоматического добавления:',
      mode: (workType, workTypeDefault = null) => mode
    }))
  },
  {
    value: 'setDefault',
    label: 'Установить режим по умолчанию',
    icon: 'mdi-undo',
    tooltip: 'Установить режим автоматического добавления работ по умолчанию для каждой работы этого комплекса',
    changedWorkTypesCaption: 'Будет установлен режим автоматического добавления по умолчанию:',
    isApplicable: (workType) => true,
    mode: (workType, workTypeDefault) => MODES.find(mode => mode.key === workTypeDefault.inclusionMode),
    beforeSetHint: 'После установки данного режима работам будет установлен режим автоматического добавления по умолчанию согласно настройкам работы в справочнике работ.'
  }
]

export const ADDITIONAL_DEPARTURE_INCLUSION_MODE_OPTIONS = [
  {
    value: 'redo',
    label: 'Повторно выполнить работы из заявки',
    icon: 'mdi-repeat-variant',
    tooltip: 'Работам в заявке будет установлен режим автоматического добавления до исполнения/повторного исполнения работы',
    children: [
      {
        parentValue: 'redo',
        value: 'redoAll',
        label: 'Повторно выполнить все работы',
        isApplicable: (workType) =>
          workType.inclusionMode === 'stopped' &&
          ['untilDone', 'stopped', 'once'].includes(workType.lastAppliedInclusionMode), // workType.lastAppliedInclusionMode !== 'always',
        changedWorkTypesCaption: 'Будут выполнены повторно:',
        mode: (workType, workTypeDefault = null) => MODES.find(mode => workType.hasDoneReports ? mode.key === 'untilDoneAgain' : mode.key === 'untilDone'),
        beforeSetHint: 'После установки данного режима выполненным работам и работам с режимом однократного добавления будет установлен режим автоматического добавления до исполнения/повторного исполнения работы'
      },
      {
        parentValue: 'redo',
        value: 'redoNotStopped',
        label: 'Повторно выполнить работы, исключая остановленные',
        isApplicable: (workType) =>
          workType.inclusionMode === 'stopped' &&
          ['untilDone', 'once'].includes(workType.lastAppliedInclusionMode), // workType.lastAppliedInclusionMode !== 'always' && workType.lastAppliedInclusionMode !== 'stopped',
        changedWorkTypesCaption: 'Будут выполнены повторно:',
        mode: (workType, workTypeDefault = null) => MODES.find(mode => workType.hasDoneReports ? mode.key === 'untilDoneAgain' : mode.key === 'untilDone'),
        beforeSetHint: 'После установки данного режима выполненным работам и работам с режимом однократного добавления, исключая остановленные вручную, будет установлен режим автоматического добавления до исполнения/повторного исполнения работы'
      }
    ]
  },
  {
    value: 'redoFromLastReport',
    label: 'Повторно выполнить работы из предыдущего отчета',
    icon: 'mdi-redo-variant',
    tooltip: 'Работам из предыдущего отчета будет установлен режим автоматического добавления до исполнения/повторного исполнения работы',
    children: [
      {
        parentValue: 'redoFromLastReport',
        value: 'redoFromLastReportAll',
        label: 'Повторно выполнить все работы из предыдущего отчета',
        isApplicable: (workType, hasNotReadyReport = false) =>
          !hasNotReadyReport &&
          workType.includedInCurrentReport &&
          workType.inclusionMode === 'stopped' &&
          ['untilDone', 'stopped', 'once'].includes(workType.lastAppliedInclusionMode), // workType.lastAppliedInclusionMode !== 'always',
        changedWorkTypesCaption: 'Будут выполнены повторно:',
        mode: (workType, workTypeDefault = null) => MODES.find(mode => workType.hasDoneReports ? mode.key === 'untilDoneAgain' : mode.key === 'untilDone'),
        beforeSetHint: 'После установки данного режима выполненным работам и работам с режимом однократного добавления будет установлен режим автоматического добавления до исполнения/повторного исполнения работы. Настройка применяется к работам, присутствовавшим в предыдущем отчете об исполнении работ.'
      },
      {
        parentValue: 'redoFromLastReport',
        value: 'redoFromLastReportNotStopped',
        label: 'Повторно выполнить работы из предыдущего отчета, исключая остановленные',
        isApplicable: (workType, hasNotReadyReport = false) =>
          !hasNotReadyReport &&
          workType.includedInCurrentReport &&
          workType.inclusionMode === 'stopped' &&
          ['untilDone', 'once'].includes(workType.lastAppliedInclusionMode), // workType.lastAppliedInclusionMode !== 'always' && workType.lastAppliedInclusionMode !== 'stopped',
        changedWorkTypesCaption: 'Будут выполнены повторно:',
        mode: (workType, workTypeDefault = null) => MODES.find(mode => workType.hasDoneReports ? mode.key === 'untilDoneAgain' : mode.key === 'untilDone'),
        beforeSetHint: 'После установки данного режима выполненным работам и работам с режимом однократного добавления, исключая остановленные вручную, будет установлен режим автоматического добавления до исполнения/повторного исполнения работы. Настройка применяется к работам, присутствовавшим в предыдущем отчете об исполнении работ.'
      }
    ]
  }
]
